import React, { useEffect, useState } from 'react';
import Toolbar from './Toolbar';
import MobileTopBar from './MobileTopBar';
import { isMobile, isTablet } from 'Utils/MediaQueryUtils';
import { ViewerTabsMode } from 'context/ViewerContext';

const TopBar: React.FC<{ 
  toolbarRef: React.RefObject<HTMLDivElement>; 
  onMobileTopBarMenuClick: () => void,
  onPropertyPanelTabClick: (tab: ViewerTabsMode | undefined) => void;
}> = ({toolbarRef, onMobileTopBarMenuClick, onPropertyPanelTabClick}) => {
  const [isMobileTopBarVisible, setIsMobileTopBarVisible] = useState(() => isMobile() || isTablet());

  useEffect(() => {
    const handleResize = () => {
      setIsMobileTopBarVisible(isMobile() || isTablet());
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="top-bar">
      <div className="top-bar-content">
        <div className="logo"></div>
      </div>
      {isMobileTopBarVisible && 
        <MobileTopBar 
          onMenuClick={onMobileTopBarMenuClick} 
          onPropertyPanelTabClick={onPropertyPanelTabClick}
        />
      }
      <Toolbar 
        toolbarRef={toolbarRef}
      />
    </div>
  );
};

export default TopBar; 